import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input"]

  connect() {
    this.formatKey()
  }

  formatKey() {
    const input = this.inputTarget
    const cursorPosition = input.selectionStart
    let value = input.value

    // Convert spaces and hyphens to underscores first
    value = value.replace(/[\s-]/g, '_')

    // Remove diacritics and normalize characters (å→a, ö→o, é→e, etc.)
    value = value.trim().normalize("NFD").replace(/\p{Diacritic}/gu, "")

    // Convert to uppercase and replace invalid characters
    value = value
      .toUpperCase()
      .replace(/[^A-Z0-9_]/g, '') // Remove any character that's not A-Z, 0-9, or _
      .replace(/^[0-9_]/, '') // Remove leading numbers and underscores
      .replace(/_+/g, '_') // Replace multiple consecutive underscores with single underscore

    input.value = value

    // Restore cursor position (adjust for removed characters)
    const newCursorPosition = Math.min(cursorPosition, value.length)
    input.setSelectionRange(newCursorPosition, newCursorPosition)
  }

  handleInput(event) {
    this.formatKey()
  }

  handleKeydown(event) {
    // Allow special keys (backspace, delete, arrow keys, etc.)
    if (event.key.length > 1) {
      return
    }

    const char = event.key

    // Block only common punctuation (allow spaces and hyphens for conversion)
    if (/[.,;:!?@#$%^&*()+=\[\]{}|\\:";'<>?,./]/.test(char)) {
      event.preventDefault()
      return
    }

    // Don't allow numbers or underscores at the beginning
    if (this.inputTarget.selectionStart === 0 && /[0-9_]/.test(char)) {
      event.preventDefault()
      return
    }
  }
}
